import React, { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { deleteObject, ref } from "firebase/storage";
import { db, storage } from "../utils/firebase";
import { uploadBytes, getDownloadURL } from "firebase/storage";

export const InputRowPages = ({
  index,
  item,
  handleChange,
  handleRemove,
  handleAdd,
  values,
  inputFields,
}) => {
  const [v, setV] = useState("");
  //image

  const fileTypes = ["JPG", "PNG", "GIF", "JPEG"];
  const [featuredImage, setFeaturedImage] = useState(null);
  const [featuredImagePath, setFeaturedImagePath] = useState(null);
  const [featuredImage2, setFeaturedImage2] = useState(null);
  const [featuredImagePath2, setFeaturedImagePath2] = useState(null);
  const [random, setRandom] = useState(null);

  const [image, setImage] = useState(item.image);
  const [image2, setImage2] = useState(item.image2);
  const uploadThumbnailProcess = () => {
    return new Promise((resolve) => {
      if (featuredImage && featuredImage.name) {
        const reference = ref(storage, featuredImagePath);
        uploadBytes(reference, featuredImage).then(() => {
          getDownloadURL(reference).then((url) => {
            resolve({ url: url, reference: featuredImagePath });

            setImage(url);
            console.log("featuredImage2", featuredImage);
          });
        });
      } else {
        setImage(featuredImage);
        console.log("featuredImage", featuredImage);
        resolve({ url: featuredImage, reference: featuredImagePath });
      }
    });
  };
  const uploadThumbnailHandler = (file) => {
    function randomName() {
      var text = "";
      var possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    }
    setFeaturedImage(file);
    setRandom(randomName());
    setFeaturedImagePath(`images/property/thumbnail/${random}${file.name}`);
  };
  const uploadThumbnailHandler2 = (file) => {
    function randomName() {
      var text = "";
      var possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    }
    setFeaturedImage2(file);
    const random = randomName();
    setFeaturedImagePath2(`images/property/thumbnail/${random}${file.name}`);
  };

  const uploadThumbnailProcess2 = () => {
    return new Promise((resolve) => {
      if (featuredImage2 && featuredImage2.name) {
        const reference = ref(storage, featuredImagePath2);
        uploadBytes(reference, featuredImage2).then(() => {
          getDownloadURL(reference).then((url) => {
            resolve({ url: url, reference: featuredImagePath });
            setImage2(url);
          });
        });
      } else {
        resolve({ url: featuredImage, reference: featuredImagePath });
        setImage2(featuredImage);
      }
    });
  };

  function randomName() {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  // end image
  useEffect(() => {
    if (item.paragraphe && item.paragraphe !== "") {
      setV("paragraphe");
    }
    if (item.title && item.title_ar !== "") {
      setV("title");
    }
    if (item.link && item.link !== "") {
      setV("link");
    }
    if (item.image && item.image !== "") {
      setV("image");
    }

    console.log("featuredImage123", featuredImage);
  }, [item]);
  useEffect(() => {
    if (image != null) {
      console.log("imageeeeeee");
      handleChange(image, index, "image");
    }

    console.log("Image", image);
  }, [image]);
  useEffect(() => {
    console.log("image2", image2);

    if (image2 != null) {
      console.log("image2");
      handleChange(image2, index, "image2");
    }
  }, [image2]);
  useEffect(() => {
    if (featuredImage != null) {
      console.log("featuredImage");
      uploadThumbnailProcess();
    }
  }, [featuredImage]);
  useEffect(() => {
    if (featuredImage2 != null) {
      console.log("featuredImage");
      uploadThumbnailProcess2();
    }
  }, [featuredImage2]);

  return (
    <div
      spacing={2}
      style={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-evenly",
        marginBottom: "35px",
      }}
    >
      <select
        name="cars"
        id="cars"
        onChange={(e) => {
          e.preventDefault();
          console.log("e", e.target.value);
          setV(e.target.value);
        }}
        defaultValue={v}
      >
        <option value="">choose a widget</option>
        <option value="paragraphe">paragraphe</option>
        <option value="title">title</option>
        <option value="link">link</option>
        <option value="image">image</option>
      </select>
      {v === "paragraphe" ? (
        <>
          <label>paragraphe</label>
          <textarea
            name="paragraphe"
            required
            fullWidth
            label="paragraphe"
            onChange={(event) => handleChange(event, index)}
            value={item.paragraphe}
          />
          <label>paragraphe_ar</label>
          <textarea
            name="paragraphe_ar"
            required
            fullWidth
            label="paragraphe_ar"
            onChange={(event) => handleChange(event, index)}
            value={item.paragraphe_ar}
          />
        </>
      ) : (
        <></>
      )}

      {v === "title" ? (
        <>
          <label>title</label>
          <input
            name="title"
            required
            fullWidth
            label="title"
            onChange={(event) => handleChange(event, index)}
            value={item.title}
          />
          <label>title_ar</label>
          <input
            name="title_ar"
            required
            fullWidth
            label="title_ar"
            onChange={(event) => handleChange(event, index)}
            value={item.title_ar}
          />
        </>
      ) : (
        <></>
      )}
      {v === "link" ? (
        <>
          <label>link</label>
          <input
            name="link"
            required
            fullWidth
            label="link"
            onChange={(event) => handleChange(event, index)}
            value={item.link}
          />
          <label>link_text</label>
          <input
            name="link_text"
            required
            fullWidth
            label="link_text"
            onChange={(event) => handleChange(event, index)}
            value={item.link_text}
          />
          <label>link_text_ar</label>
          <input
            name="link_text_ar"
            required
            fullWidth
            label="link_text_ar"
            onChange={(event) => handleChange(event, index)}
            value={item.link_text_ar}
          />
        </>
      ) : (
        <></>
      )}
      {v === "image" ? (
        <>
          <label>image</label>
          <FileUploader
            classes="dropzone"
            handleChange={uploadThumbnailHandler}
            name="image"
            onChange={(event) => handleChange(event, index)}
            types={fileTypes}
            value={image}
          />
          <input
            name="image"
            required
            fullWidth
            className="d-none"
            label="text"
            type="text"
            onChange={(event) => handleChange(event, index)}
            value={image}
          />
          <label>image_2</label>
          <input
            name="image2"
            className="d-none"
            required
            fullWidth
            label="text"
            type="text"
            onChange={(event) => {
              console.log(event);
              handleChange(event, index);
            }}
            value={image2}
          />
          <FileUploader
            classes="dropzone"
            handleChange={uploadThumbnailHandler2}
            name="image2"
            types={fileTypes}
            onChange={(event) => handleChange(event, index)}
            value={image2}
          />
        </>
      ) : (
        <></>
      )}

      <div>
        <button
          onClick={(e) => {
            e.preventDefault();
            handleRemove(index);
          }}
          style={{
            color: "white",
            backgroundColor: "red",
            border: "none",
            borderRadius: "7px",
            marginRight: "4px",
          }}
        >
          remove
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            handleAdd();
          }}
          style={{
            color: "white",
            backgroundColor: "green",
            border: "none",
            borderRadius: "7px",
            marginRight: "4px",
          }}
        >
          add
        </button>
      </div>
    </div>
  );
};
